import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";

const REVIEW_COMMENTS_FIELDS: Field[] = [
  {
    id: "comments",
    type: ControlType.TextArea,
    label: "Comments / Remarks",
    order: 1,
    propertyName: "comments",
    value: "",
    required: true,
    visible: true,
    valid: false,
    readOnly: false,
  },
];

export const REVIEW_COMMENTS_FORM: Section[] = [
  {
    id: "1",
    name: "",
    isFixed: true,
    order: 1,
    fields: REVIEW_COMMENTS_FIELDS,
    actions: [],
  },
];

export const REVIEW_COMMENTS_CONTROLS: any[] = [
  {
    id: "comments",
    maxLength: 1500,
  },
];
